import { inject } from "vue";
import type { CollectibleSDK as CollectibleSDKType } from "@manifoldxyz/collectible-sdk/dist/CollectibleSDK";

export const useCollectibleSDK = (): CollectibleSDKType => {
  const _collectibleSDK = inject("collectibleSDK") as CollectibleSDKType;

  return _collectibleSDK as CollectibleSDKType;
};
